import Util from '../../../util/index.js';
import DataMap from './datamap';
/**
 * 所有db的基类
 */
export default class BaseDB extends DataMap {
  constructor(props = {}) {
    super();
    const { api, threshold } = props;
    this.api = api;
    this.threshold = threshold;
    this.period = null;
    this.code = null;
    this.business_type = undefined;
  }
  async query({fn, key, threshold, args, context}) {
    // 不指定key时，fn设为key
    if (Util.isUndefined(key)) {
      key = fn;
    }
    let _threshold = this.threshold && !Util.isUndefined(threshold) ? threshold : this.threshold;
    // 设置了缓存时间，读取本地缓存
    let nowStamp = new Date().getTime();
    if (_threshold) {
      if (this.has(key)) {
        let value = this.get(key);
        let lastStamp = value.timeStamp;
        if (lastStamp + _threshold > nowStamp) {
          return value.data;
        }
        // 清空时间戳，发送请求
        this.delete(key);
      }
    }
    let data;
    if (context) {
      data = await fn.apply(context, args);
    } else {
      data = await fn();
    }
    this.set(key, {
      timeStamp: nowStamp,
      data
    });
    return data;
  }
  async update({fn, key, threshold, args, context}) {
    // 不指定key时，fn设为key
    if (Util.isUndefined(key)) {
      key = fn;
    }
    let _threshold = this.threshold && !Util.isUndefined(threshold) ? threshold : this.threshold;
    let data;
    if (context) {
      data = await fn.apply(context, args);
    } else {
      data = await fn();
    }
    let nowStamp = new Date().getTime();
    this.set(key, {
      timeStamp: nowStamp,
      data
    });
    return data;
  }
}
